import axios from 'axios'
export default {
  namespaced: true,
  state() {
    return {
      load: false,
      loaded: false,
      error: false,
      repeated_invites: []
    }
  },
  mutations: {
    set_load(state, v) { state.load = v; },
    set_loaded(state, v) { state.loaded = v; },
    set_error(state, v) { state.error = v; },
    set_repeated_invites(state, v) { state.repeated_invites = v; }
  },
  actions: {
    send(context, value) {
      context.commit('set_loaded', true);

      return axios.post('/1.0/express-invites', {invites: [value]})
        .then(r => {
          context.commit('set_error', null);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        });
    },

    check_dublicate(context, value) {
      context.commit('set_loaded', true);

      return axios.post(`/1.0/invites/check-duplicate?force=0`, {invites: [value]})
        .then(r => {
          context.commit('set_repeated_invites', r.data.data);
          context.commit('set_error', null);
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          throw err;
        })
    }
  },
  getters: {
    load: state => state.load,
    loaded: state => state.loaded,
    error: state => state.error,
    repeated_invites: state => state.repeated_invites
  }
}